import $ from 'jquery';

import {
  loadAlpineAsync,
  loadMatchHeightAsync,
} from '@/src/utilities/script-loader';

export async function load() {
  if (!document.querySelector('#companyExecutiveModal')) {
    return;
  }

  await loadMatchHeightAsync();

  // @ts-ignore
  $('.equal').matchHeight({
    byRow: false,
  });

  const Alpine = await loadAlpineAsync();

  /**
   * Initializes an ExecutiveComponent, retrieving its state from the window.companyExecutives.data object
   * by the ExecutiveComponent.fullname value as a key
   */
  Alpine.data('executive', (executiveFullname) => {
    if (!(typeof executiveFullname === 'string')) {
      return {};
    }

    /** @type {{[key: string]: Executive | undefined}} */
    const data = window.companyExecutives.data;
    const executive = data[executiveFullname];

    if (!executive) {
      return {};
    }

    /** @type {Executive & Record<string, any>}} */
    return {
      ...executive,
      sendModalEvent,
    };
  });

  /**
   * Sends a 'modal-event' from an Executive Component which is handled by the page's Modal Component
   *
   * @this {ExecutiveComponent}
   * @param {MouseEvent} _$event
   * @param {(eventName: string, payload: any) => void} $dispatch
   */
  function sendModalEvent(_$event, $dispatch) {
    $dispatch('modal-event', {
      fullname: this.fullname,
      photoURL: this.photoURL,
      companyTitle: this.companyTitle,
      descriptionHTML: this.$refs.descriptionHTML.innerHTML,
    });
  }

  /**
   * Initializes the Modal Component's state, which is empty until a 'modal-event' is handled
   */
  Alpine.data('modal', () => ({
    fullname: '',
    photoURL: '',
    descriptionHTML: '',
    companyTitle: '',
    handleModalEvent,
  }));

  /**
   * Handles a 'modal-event' sent by an Executive Component by updating the Modal Component's properties
   * and opening the Bootstrap modal
   *
   * @this {ModalComponent}
   * @param {{ detail: Executive }} $event
   */
  function handleModalEvent($event) {
    const { fullname, photoURL, companyTitle, descriptionHTML } = $event.detail;

    this.fullname = fullname;
    this.photoURL = photoURL;
    this.companyTitle = companyTitle;
    this.descriptionHTML = descriptionHTML;

    $('#companyExecutiveModal').modal();
  }

  Alpine.start();
}

/**
 * @typedef Executive
 * @property {string} fullname
 * @property {string} companyTitle
 * @property {string} photoURL
 * @property {string} descriptionHTML
 */

/**
 * @typedef ExecutiveComponent
 * @property {string} fullname
 * @property {string} companyTitle
 * @property {string} photoURL
 * @property {string} descriptionHTML
 * @property {{ descriptionHTML: HTMLElement }} $refs
 */

/**
 * @typedef ModalComponent
 * @property {string} fullname
 * @property {string} companyTitle
 * @property {string} photoURL
 * @property {string} descriptionHTML
 * @property {Function} handleModalEvent
 */
